import React, { useEffect, useState } from "react";
import { Drawer, Form, Col, Row, theme } from "antd";

export default ({ detail }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <a onClick={() => setOpen(true)}>查看详情</a>
      <Drawer
        title="详情"
        width={500}
        destroyOnHidden
        open={open}
        onClose={() => setOpen(false)}
      >
        <Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
          <Form.Item label="ID">{detail.id}</Form.Item>
          <Form.Item label="标题">{detail.title}</Form.Item>
          <Form.Item label="内容类型">{detail.contentType}</Form.Item>
          <Form.Item label="举报人">{detail.reporter}</Form.Item>
          <Form.Item label="举报时间">{detail.reportDate}</Form.Item>
          <Form.Item label="内容状态">{detail.status}</Form.Item>
        </Form>
      </Drawer>
    </>
  );
};
